import React, { useEffect, useState } from "react";
import DTOUpdatePasswordModal from "./DTOUpdatePasswordModal";
import UpdatePasswordModalPresenter from "./UpdatePasswordModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../infra/hooks";
import { updatePersonalDetailsService } from "../../../api/services/updatePersonalDetailsService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  isCardUpdate?: (data: boolean) => void;
}

const UpdatePasswordModalController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state?.authSlice);
  const { t } = useTranslation();

  const getData = (data: any) => {
    updatePassword(data);
  };

  async function updatePassword(data: any) {
    if (selector.company_id) {
      const payload = {
        emp_id: selector.emp_id,
        old_password: data.password,
        password: data.newPassword,
        confirm_password: data.confirmPassword,
      };
      await updatePersonalDetailsService
        .updatePassword(payload)
        .then((response: any) => {
          if (response.response == "success") {
            toast.success(t("Password Changed Successfully"));
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data);
        });
    } else {
      toast.error(t("Company Id not found"));
    }
  }

  return (
    <div>
      <DTOUpdatePasswordModal />

      <UpdatePasswordModalPresenter
        callBackHandleClockIn={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
      />
    </div>
  );
};

export default UpdatePasswordModalController;
